import { FleekError } from './FleekError';

type GitProviderNotSupportedErrorOptions = {
  provider: string;
};

export class GitProviderNotSupportedError extends FleekError<GitProviderNotSupportedErrorOptions> {
  public name = 'GitProviderNotSupportedError';

  toString = () => `Git provider: ${this.data.provider} not Supported`;
}
